import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { RouteBean } from './model/RouteBean';
import { RouteBeanTable } from './model/RouteBeanTable';
import { RouterService } from './services/router.service';
import { CanComponentDeactivate } from '../utility/can-exit.guard';
import { ConfirmationService, FilterMetadata, SortEvent } from 'primeng/api';
import { NgbPagination, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment-timezone';
import { Table } from 'primeng/table';
import { EditRouteComponent } from './edit-route/edit-route.component';
import { cloneDeep } from 'lodash';
import { SessionStorageService } from '../administration/services/session-storage.service';

@Component({
  selector: 'app-router',
  templateUrl: './router.component.html',
  styleUrls: ['./router.component.css'],
})
export class RouterComponent implements CanComponentDeactivate, AfterViewInit, AfterContentChecked {
  constructor(
    private routerService: RouterService,
    private confirmationService: ConfirmationService,
    private ngbConfig: NgbPaginationConfig,
    private cdr: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService
  ) {
    this.ngbConfig.ellipses = true;
  }
  @ViewChild('dt2') dt2!: Table;
  @ViewChild('pagination') pagination!: NgbPagination;

  @ViewChild('editRouteComponent') editRouteComponent: EditRouteComponent;

  tableViewRoutes: RouteBeanTable[];
  fullRouteData: RouteBeanTable[];
  showEdit: boolean;
  allRoutes: RouteBeanTable[];
  origResp: RouteBean[];
  particularRow: any;
  originalParticularRow: any;
  tableName: string = 'routeTable';
  sortField: string;
  sortOrder: number;
  currentPage = 1;
  rowsPerPage = 15;
  totalRecords: number;
  currentSort: SortEvent;
  dontShowExpChecked: boolean;
  showOnlyLegacyRoutesChecked: boolean;
  dataInitialized: boolean = false;

  onRowSelect(event: any) {
    this.routerService.getParticularRoutes(event.data.uuid).then((data) => {
      this.originalParticularRow = cloneDeep(data);
      this.particularRow = cloneDeep(data);
    });
    this.showEdit = true;
		  }

  @HostListener('window:beforeunload')
  canDeactivate(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const periodsMatch = this.comparePeriodArrays(
        this.particularRow?.periods ?? [],
        this.editRouteComponent?.editRouteform.dateArray ?? []
      );
      const isActiveMatch =
        this.particularRow &&
        this.particularRow.isActive !==
          this.editRouteComponent.editRouteform.isActive;

      if (!periodsMatch || isActiveMatch) {
        this.confirmationService.confirm({
          message:
            'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
          header: 'Ændringer er ikke gemt',
          rejectLabel: 'Nej',
          acceptLabel: 'Ja',
          accept: () => {
            this.routerService.dateArray = this.particularRow = undefined;
            resolve(true);

          },
          reject: () => {
            resolve(false);
          },
        });
      } else {
        this.routerService.dateArray = this.particularRow = undefined;
        resolve(true);
      }
    });
  }

  comparePeriodArrays(arr1: any[], arr2: any[]): boolean {
    if (arr1?.length !== arr2?.length) {
      return false;
    }

    arr1.sort((a, b) => a.periodUuid.localeCompare(b.periodUuid));
    arr2.sort((a, b) => a.periodUuid.localeCompare(b.periodUuid));

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].uuid !== arr2[i].uuid) {
        return false;
      }
      if (!this.compareObjects(arr1[i], arr2[i])) {
        return false;
      }
    }
    return true;
  }

  private compareObjects(obj1: any, obj2: any) {
    return (
      new Date(obj1.validFrom).getDate() ===
        new Date(obj2.validFrom).getDate() &&
      new Date(obj1.validTo).getDate() === new Date(obj2.validTo).getDate()
    );
  }

  ngOnInit() {
    this.sortField = 'infRef';
    this.sortOrder = 1;
    if (sessionStorage.getItem(this.tableName)) {
      let tableStorage = JSON.parse(
        sessionStorage.getItem(this.tableName) + ''
      );
      this.sortField = tableStorage.sortField
        ? tableStorage.sortField
        : this.sortField;
      this.sortOrder = tableStorage.sortOrder
        ? tableStorage.sortOrder
        : this.sortOrder;
    }
    this.routerService.getAllRoutes().then((data) => {
      if (data) {
        this.origResp = data;
        const data1 = data.map((d) => {
          const x: any = {};
          x.uuid = d.uuid;
          x.infRef = d.key.infRef?.infRefName;
          x.isManagedSA = d.isManagedSA;
          x.senderAuthority = d.key.senderAuthority?.name;
          x.recipientAuthority = d.key.recipientAuthority?.name;
          x.routingType = d.key.infRef?.routingType;
          x.senderItSystem = d.key.senderItSystem?.name;
          x.recipientItSystem = d.key.recipientItSystem?.name;
          x.startDate = this.getDateValueForRoute(d.validFrom);
          x.endDate = this.getDateValueForRoute(d.validTo);
          x.isActive = d.isActive ? 'Aktiv' : 'InAktiv';
          x.canEdit = d.canEdit;
          return x;
        });
        this.allRoutes = data1;
        this.fullRouteData = data1;
        this.totalRecords = data1.length;
        if (this.showPagination) {
          const firstItemIndex = (this.currentPage - 1) * this.rowsPerPage;
          this.tableViewRoutes = this.fullRouteData.slice(firstItemIndex, firstItemIndex + this.rowsPerPage);
          this.dataInitialized = true;
        }
        else {
          this.tableViewRoutes = data1;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    const savedStateString = sessionStorage.getItem(this.tableName);
    if (savedStateString) {
      const savedState = JSON.parse(savedStateString);
      if (
        savedState &&
        savedState.first !== undefined &&
        savedState.rows !== undefined
      ) {
        this.dt2.first = savedState.first;
        this.dt2.rows = savedState.rows;
      }
    }
    this.inputChange("","");
  }

  ngAfterContentChecked(): void {
    if (this.dataInitialized && this.dt2?.value) {
      this.dataInitialized = false;
      this.inputChange("", "");
      this.initPagination();
    }
  }

  dontShowExp(e: any) {
    if (e.checked) {
      this.dontShowExpChecked = true;
      if(this.showOnlyLegacyRoutesChecked) {
        this.fullRouteData = this.fullRouteData.filter(
          (x) => x.routingType.toLowerCase() === 'implicit'
        );
      } else {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.routingType.toLowerCase() === 'implicit'
        );
      }
    } else {
		  this.dontShowExpChecked = false;
      if(this.showOnlyLegacyRoutesChecked) {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.isManagedSA === false
        );
      } else {
        this.tableViewRoutes = this.allRoutes;
      }
    }
    this.onPageChange(1);
    this.inputChange("","");
  }

  getDateValueForRoute(dvalue: any) {
    if (dvalue != null) {
      let localDate = new Date(dvalue);
      return moment(
        new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate())
      ).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  showOnlyLegacyRoutes(e: any) {
    if (e.checked) {
      this.showOnlyLegacyRoutesChecked = true;
      if(this.dontShowExpChecked) {
        this.fullRouteData = this.fullRouteData.filter(
          (x) => x.isManagedSA === false
        );
      } else {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.isManagedSA === false
        );
      }
    } else {
      this.showOnlyLegacyRoutesChecked = false;
      if(this.dontShowExpChecked) {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.routingType.toLowerCase() === 'implicit'
        );
      } else {
        this.tableViewRoutes = this.allRoutes;
      }      
    }
    this.inputChange("","");
    this.onPageChange(1);
    
  }
  cancelClick() {
    this.particularRow = null;
    this.routerService.dateArray = undefined;
    this.showEdit = false;
  }

  editSubmit() {
    this.particularRow = null;
    this.ngOnInit();
    this.showEdit = false;
  }

  onPageChange(pageNumber:number){
    this.savePagination(pageNumber);
    this.currentPage = pageNumber;
    this.tableViewRoutes = this.fullRouteData.slice((pageNumber - 1) * this.rowsPerPage,
         (pageNumber - 1) * this.rowsPerPage + this.rowsPerPage); 
   }
 
   get showPagination(): any {
     return this.rowsPerPage && (this.rowsPerPage > 0) && (this.fullRouteData?.length > this.rowsPerPage);
   }
   dynamicSort(property: any) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a:any,b:any) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

 
  customSort(event: SortEvent) {
    if (!this.currentSort) {
      this.currentSort = event;
    }

    this.sortField = event.field ? event.field : this.sortField;
    this.sortOrder = event.order ? event.order : this.sortOrder;

    let property = event.field as keyof RouteBeanTable;

    if (property) {

      this.fullRouteData.sort((data1: any, data2: any) => {
        let value1 = data1[property];
        let value2 = data2[property];
        let result = null;

        let newOrder = event.order ? event.order : 0;

        result = value1?.toString().localeCompare(value2?.toString());

        return (newOrder * result);
      })
    }

    if(this.fullRouteData?.length < this.rowsPerPage) {
      this.tableViewRoutes = this.fullRouteData.slice(0, this.rowsPerPage);
    }

    if (this.currentSort.field !== event.field || this.currentSort.order !== event.order) {
      this.pagination?.pageChange?.emit(1);
      if (this.pagination) {
        this.pagination.page = 1;
      }
      this.currentSort = event;
    }

    if(this.pagination) {
      this.pagination.page = 1;
    }
  }

  inputChange(inputValue: string, field: string) {
    if (this.fullRouteData) {
      let filters = Object.entries(this.dt2.filters).map((e) => ({ [e[0]]: e[1] }));
      if (field && filters) {
        for (const filter of filters) {
          if (filter[field] != null) {
            this.dt2.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          } else {
            this.dt2.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          }
        }
      } else {
        this.dt2.filters[field] = {
          value: inputValue,
          matchMode: "contains"
        }
      }

      filters = Object.entries(this.dt2.filters).map((e) => ({ [e[0]]: e[1] }));

      this.fullRouteData = this.allRoutes;
      if (this.showOnlyLegacyRoutesChecked) {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.isManagedSA === false
        );
      }
      if (this.dontShowExpChecked) {
        this.fullRouteData = this.allRoutes.filter(
          (x) => x.routingType.toLowerCase() === 'implicit'
        );
      }

      for (const f of filters) {
        let property = Object.keys(f).at(0) as keyof RouteBeanTable;
        let filterMetadata = f[property] as FilterMetadata;
        if (filterMetadata.value) {
          this.fullRouteData = this.fullRouteData.filter(data => data[property]?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));
        }
      }
      this.totalRecords = this.fullRouteData.length;
      if (this.fullRouteData?.length > 0) {
        this.pagination?.pageChange?.emit(1);
        if(!this.pagination) {
          this.onPageChange(1);
        } else {
          this.pagination.page = 1;
        }
      }

    }
  }

  private savePagination(page: number) {
    this.sessionStorageService.put(this.sessionStorageService.ROUTER_PAGINATION, page);
  }

  private initPagination() {
    let page = this.sessionStorageService.get(this.sessionStorageService.ROUTER_PAGINATION);
    if (this.pagination?.pageCount < page) {
      this.pagination?.pageChange?.emit(this.pagination.pageCount);
      if (this.pagination) {
        this.pagination.page = this.pagination.pageCount;
      }
    } else {
      this.pagination?.pageChange?.emit(page);
      if (this.pagination) {
        this.pagination.page = page;
      }
    }
  }

}
